import { apiErrorMessage } from './apiErrorMessage';

export const sqisGenerationErrorMessage = (error) => {
  const status = error?.response?.status;
  if (!status) {
    return error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT'
      ? 'The SQIS request timed out. Reload the saved report before retrying.'
      : 'Could not connect to the server. Check your connection and reload the saved report before retrying.';
  }
  if (status === 502 || status === 503 || status === 504) {
    return 'The generation service is temporarily unavailable or timed out. Reload the saved report before retrying.';
  }
  if (status >= 500) {
    return 'SQIS generation failed on the server. Reload the saved report before retrying.';
  }
  // Validation/authorization/concurrency errors are the authoritative backend
  // decision. Do not infer completion from the navigation or progress display.
  return apiErrorMessage(error, 'SQIS generation was rejected. Please retry.');
};
